import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class PrUtilityService {
  constructor() {}

  checkValue(value: string, defaultValue: string) {
    return value || defaultValue;
  }

  roundDecNumber(num: number, decimalPlace: number) {
    const factor = Math.pow(10, decimalPlace);
    return Math.round(num * factor) / factor;
  }

  roundDecimal(val: number) {
    return Number((Math.round(val * 100) / 100).toFixed(2));
  }

  roundDecimalForFinal(val: number) {
    return val.toFixed(1);
  }

  isAdvsrMinBuyWarningReqd(txnAmt: number, initialBuyAmt: number, subsequentBuyAmt: number, mayHaveChildren: boolean) {
    if (mayHaveChildren) {
      if (txnAmt < subsequentBuyAmt) {
        return false;
      }
      return true;
    } else {
      if (txnAmt < initialBuyAmt) {
        return false;
      }
      return true;
    }
  }

  getFloat(a: number, n: number) {
    const s = a.toString();
    const r = new RegExp("(^-?\\d+\\.\\d{" + n + "})(\\d)");
    const m = s.match(r);
    return m != null ? parseFloat(m[1]) : parseFloat(s);
  }
}
